import { apiFetch } from '../helpers/api-fetch';
import { User } from '../models/user';
import { Role } from '../helpers/role';

export class UserService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string; // API server domain

    // Get all Users
    public static async getAll() {
        const res = await apiFetch(`${UserService.APIUrl}/api/users`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Get User by id
    public static async getById(id: string) {
        const res = await apiFetch(`${UserService.APIUrl}/api/users/${id}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Register a new User or update its data
    public static createOrUpdate(registerUser: User) {
        // set username and role
        registerUser.username = registerUser.email;
        registerUser.role = Role.User;
        //check for default ids and set them to undefined       
        registerUser.mentorId = registerUser.mentorId == 0 ? undefined : registerUser.mentorId;
        registerUser.representativeId = registerUser.representativeId == 0 ? undefined : registerUser.representativeId;

        return apiFetch(`${UserService.APIUrl}/api/users`, {
            method: 'POST',
            body: JSON.stringify(registerUser)
        }).then(res => {
            return Promise.resolve(res);
        });
    }



}